<div class="pcheck-card">
  <div class="pcheck-card__header">
    <i class="pi pi-calendar" aria-hidden="true"></i>
    <span>Reschedule Meeting — {{ details.executive }}</span>
  </div>
  <div class="pcheck-card__body">

    @if (showTzPicker) {
      <div class="pcheck-card__tz">
        <span class="pcheck-card__tz-label">Times in</span>
        <app-timezone-select [value]="displayTz()" [compact]="true" (valueChange)="onTimezoneChange($event)"></app-timezone-select>
      </div>
    }

    <app-meeting-detail-table
      [accountName]="details.account_name"
      [executive]="details.executive"
      [subject]="details.subject"
      [startTime]="details.start_time"
      [displayTimezone]="displayTz()"
      [attendeeEmail]="details.attendee_email"
      [additionalGuests]="details.additional_guests">
    </app-meeting-detail-table>

    @if (confirmed) {
      <div class="pcheck-card__confirmed">
        <i class="pi pi-check-circle" aria-hidden="true"></i> Rescheduled
      </div>
    } @else {
      <div class="pcheck-card__actions">
        <a class="pcheck-btn pcheck-btn--link"
          [href]="rescheduleUrl" target="_blank" rel="noopener noreferrer">
          <i class="pi pi-external-link" aria-hidden="true"></i> Open Reschedule Page
        </a>
        <button type="button" class="pcheck-btn pcheck-btn--done" (click)="onConfirm()">
          <i class="pi pi-check-circle" aria-hidden="true"></i> I've Rescheduled
        </button>
      </div>
    }

  </div>
</div>
